import React, { useState } from 'react';
import { X, CheckCircle, XCircle } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { complianceService } from '../../services/api';
import { getAttachmentUrl } from '../../utils/helpers';

const VerifyModal = ({ isOpen, onClose, onVerified, compliance }) => {
  const [remark, setRemark] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  if (!isOpen || !compliance) return null;

  const handleAction = async (status) => {
    try {
      setIsProcessing(true);
      const res = await complianceService.verifyCompliance(compliance._id, {
        verificationStatus: status,
        reason: remark || undefined,
      });
      if (res?.success) {
        toast.success(`Marked as ${status}`);
        onVerified?.();
        onClose();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message || 'Failed to update');
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Verify Compliance</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          {compliance.cloudinaryURL ? (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Uploaded Document</label>
              <a
                href={getAttachmentUrl(compliance.cloudinaryURL)}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline break-all"
              >
                View Document
              </a>
            </div>
          ) : (
            <p className="text-sm text-gray-500">No document uploaded.</p>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Remark (visible only to Super Admin)</label>
            <textarea
              rows={3}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Add internal remark"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 p-4 border-t border-gray-200">
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
            Close
          </button>
          <button
            onClick={() => handleAction('rejected')}
            disabled={isProcessing}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:opacity-50"
          >
            <XCircle className="h-4 w-4 mr-2" /> Reject
          </button>
          <button
            onClick={() => handleAction('approved')}
            disabled={isProcessing}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-green-600 hover:bg-green-700 disabled:opacity-50"
          >
            <CheckCircle className="h-4 w-4 mr-2" /> Approve
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyModal;


